export const clubs = [
  '/club1.webp',
  '/club2.webp',
  '/club3.webp',
  '/club4.webp',
  '/club5.webp',
  '/club6.webp',
  '/club7.webp',
  '/club9.webp',
  '/club10.webp',
  '/club11.webp',
  '/club12.webp',
];
